
import { Component, Prop, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import ImageView from './ImageView.vue';
import Input from './Input.vue';
import ChatRating from '@/views/Chatroom/ChatRating.vue';

import * as PleasedApi from '@/common/api/api.pleased';
import * as PleasedModel from '@/common/api/models.pleased';
import loading from '@/components/loading';
import { UserTicket } from '../../common/api/model';
import { CMP_CONTEXTS } from '@/common/logs/events';
import LogPageEventMixin, { PAGE_TRACKING, PAGE_EVENTS } from '@/mixins/logPageEvent';
import { mixins } from 'vue-class-component';

@Component({
  components: {
    Header,
    Input,
    ImageView,
    ChatRating,
  },
  filters: {
    formatDate (requestTime: string) {
      const options = { month: 'long', year: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' } as const;
      const requestCreated = new Date(requestTime);
      return requestCreated.toLocaleString(undefined, options);
    },
    formatTime (requestTime: string) {
      const options = { hour: 'numeric', minute: 'numeric' } as const;
      const requestCreated = new Date(requestTime);
      return requestCreated.toLocaleString(undefined, options);
    },
    capitalize (word: string) {
      if (word) {
        return word[0].toUpperCase() + word.substring(1);
      }
    },
    titleCase (str: string) {
      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
      );
    },
  },
  directives: {
    loading,
  },
})
export default class MyRequestDetail extends mixins(LogPageEventMixin) {
  @Prop({ default: {} }) readonly ticketId!: string;
  @Prop({ default: {} }) readonly initialTicket!: UserTicket;

  readonly CMP_CONTEXTS = CMP_CONTEXTS;

  ticket: any = this.initialTicket;
  ticketReviews: PleasedModel.EntityReview[] = [];
  commentList: PleasedModel.Comment[] = [];
  addCommentSelect: boolean = false;
  scrollable: boolean = false;
  scrolledDown: boolean = true;
  showAttachment: boolean = false;
  selectedAttachment = {} as {title: string, url: string};
  uploading: boolean = false;
  loading: boolean = false;
  // TODO: uncomment or remove commented code for showing chat rating here
  // loadingReviews: boolean = false;
  // feedbackCategories: PleasedModel.FeedbackCategory[] = [];
  submittedFeedback: boolean = false;

  mounted () {
    this.loading = true;
    // this.loadingReviews = true;
    this.getDetails().then(() => {
      this.loading = false;
    });
    this.getCommentList();
    this.isScrollable();

    // this.getReviews().then(() => {
    //   this.loadingReviews = false;
    // });

    // PleasedApi.getFeedbackSelections().then(r => {
    //   this.feedbackCategories = r;
    // });
  }

  updated () {
    this.isScrollable();
  }

  get [PAGE_TRACKING] () {
    return { name: PAGE_EVENTS.MY_REQUESTS_DETAIL, ticketId: this.ticket.id };
  }

  get needsActionButton () {
    return !this.ticketSolvedOrClosed;
  }
  get ticketStatus () {
    const { status } = this.ticket;
    return this.ticketSolvedOrClosed ? status : 'Active';
  }

  get ticketSolvedOrClosed () {
    return this.ticket && ['solved', 'closed', 'resolved'].includes(this.ticket.status?.toLowerCase());
  }

  get isActive () {
    return this.ticketStatus === 'Active';
  }
  get headerTitle () {
    const { ticketStatus } = this;
    return this.$t('page.my_request.request_details', { ticketStatus });
  }

  // get showRating () {
  //   return !this.submittedFeedback && !this.loadingReviews && this.ticketReviews.length === 0;
  // }

  isScrollable () {
    const container = (this.$refs.container as HTMLDivElement);
    if (container.scrollHeight <= container.clientHeight + 100) {
      this.scrollable = false;
    } else {
      if (container.scrollTop + container.clientHeight / 2 < container.scrollHeight / 2) {
        this.scrolledDown = false;
      } else {
        this.scrolledDown = true;
      }
      this.scrollable = true;
    }
  }
  getCommentList () {
    PleasedApi.getTicketComments(parseInt(this.ticketId)).then(res => {
      this.commentList = res.data;
      this.$nextTick(() => {
        this.scrollToEnd();
      });
      return res.data;
    });
  }
  getDetails () {
    return PleasedApi.getTicket(parseInt(this.ticketId)).then(ticket => {
      if (ticket.updatedAt !== this.ticket.updatedAt) {
        this.$emit('update-ticket');
      }

      this.ticket = ticket;
    });
  }

  async getReviews () {
    const { reviews } = await PleasedApi.getEntityReview({ entityType: 'ticket', entityId: parseInt(this.ticketId) });
    const ticketReviews = reviews.filter(review => review.type === 'TICKET');
    this.ticketReviews = ticketReviews;
  }

  handleBack () {
    this.$emit('back');
  }
  addComment () {
    this.addCommentSelect = true;
  }
  submitComment (comment: string) {
    PleasedApi.addTicketComment({ comment, ticketId: this.ticket.id })
      .then(() => { this.getDetails(); this.getCommentList(); });
  }
  attachImage (image: File, details: string) {
    this.uploading = true;
    PleasedApi.addAttachmentComment({ file: image, ticketId: this.ticket.id })
      .then(() => this.getCommentList())
      .finally(() => {
        this.uploading = false;
        return this.getDetails();
      });
  }
  handleShowAttachment (attachment: PleasedModel.TicketAttachment) {
    const { fileName, url } = attachment;
    this.selectedAttachment.title = fileName;
    this.selectedAttachment.url = url;
    this.showAttachment = true;
  }
  isAttachmentImage (attachment: PleasedModel.TicketAttachment) {
    return /^image/.test(attachment.contentType);
  }

  // postFeedback (config: {rating: number, comment: string, feedbackSelectionIds: number[]; type: 'voice' | 'chat'}) {
  //   const { rating, comment, feedbackSelectionIds, type } = config;

  //   PleasedApi.postFeedback({
  //     rating,
  //     comment,
  //     feedbackSelectionIds,
  //     type,
  //     chatOrVoiceId: this.ticket.id,
  //   });
  // }
  // handleFeedback (config: {rating: number, comment: string, feedbackSelectionIds: number[]; type: 'voice' | 'chat'}) {
  //   setTimeout(() => {
  //     this.submittedFeedback = true;
  //   }, 2000);

  //   this.postFeedback(config);
  // }

  scrollToEnd () {
    const container = (this.$refs.container as HTMLDivElement);
    container.scrollTop = container.scrollHeight;
  }
  scrollToTop () {
    const container = (this.$refs.container as HTMLDivElement);
    container.scrollTop = 0;
  }
}
